import * as React from "react";
import { IMaskInput } from "react-imask";
import { ThemeProvider, createTheme } from "@mui/material";
import TextField from "@mui/material/TextField";
import { StylesProvider } from "@material-ui/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

interface URLMaskCustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const theme = createTheme({
  direction: "ltr",
});

const cacheRtl = createCache({
  key: "muiltr",
  stylisPlugins: [prefixer, rtlPlugin],
});

const urlPattern = /^(https?:\/\/www\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}|www\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})$/;

const URLMaskCustom = React.forwardRef<HTMLElement, URLMaskCustomProps>(
  function URLMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask={/.*?/}
        definitions={{
          "*": /[a-zA-Z0-9.:/-]/,
        }}
        onAccept={(value: any) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
      />
    );
  }
);

interface WebsiteInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeHolder: string;
  name: string;
  id: string;
}

export default function WebsiteInput({
  value,
  onChange,
  label,
  placeHolder,
  name,
  id,
}: WebsiteInputProps) {
  const [error, setError] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (!urlPattern.test(value)) {
      setError(true);
      setErrorText("لطفاً یک آدرس معتبر وارد کنید.");
    } else {
      setError(false);
      setErrorText("");
    }
  };

  return (
    <StylesProvider>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <TextField
            label={label}
            variant="outlined"
            InputProps={{ inputComponent: URLMaskCustom as any }}
            placeholder={placeHolder}
            fullWidth
            value={value}
            onChange={onChange}
            onBlur={handleBlur}
            name={name}
            id={id}
            error={error}
            helperText={errorText}
            InputLabelProps={{
              sx: {
                top: "-4px",
                "&.MuiInputLabel-shrink": {
                  top: "0px",
                },
              },
            }}
          />
        </ThemeProvider>
      </CacheProvider>
    </StylesProvider>
  );
}
